import PortalIdParser from 'PortalIdParser';
import { useQuery } from 'data-fetching-client';
import { GET_NON_ENROLLMENT_DIAGNOSIS } from 'flow-doctor-lib/queries/FlowDoctorQueries';
const useNonEnrollmentDiagnosis = ({
  flowId,
  objectId,
  timelineItem
}) => {
  const {
    data: nonEnrollmentData,
    loading: nonEnrollmentLoading,
    error: nonEnrollmentError
  } = useQuery(GET_NON_ENROLLMENT_DIAGNOSIS, {
    variables: {
      portalId: PortalIdParser.get(),
      flowId,
      objectId,
      timelineItem
    }
  });
  return {
    data: nonEnrollmentData && nonEnrollmentData.nonEnrollmentDiagnosis,
    loading: nonEnrollmentLoading,
    error: nonEnrollmentError
  };
};
export default useNonEnrollmentDiagnosis;